import { JSX } from 'react';
import './style.scss';

export default function Link({title, url, icon, onClick}: { title: string; url: string; icon: JSX.Element; onClick?: () => void }) {
  return (
    <p className="link" onClick={onClick}>
      <span className="icon">
        {icon}
      </span>
      <a href={url}>{title}</a>
    </p>
  );
}